<template>
  <HeaderWrapper v-if="!hideHeader" />
  <main
    :class="{
      _widget: isWidgetPage,
      _full: hideHeader,
      _footer: isFooter && store.getters.screenType !== 'mobile',
    }"
  >
    <VNav v-if="isMenuShown" />
    <router-view />
    <NoticeList v-if="isNotices" />
  </main>
  <Footer v-if="isFooter" />
  <ModalContainer />
  <ModalMobileContainer />
  <CookieModal v-if="showCookie" />
</template>

<script setup>
import { useWindowSize } from "@vueuse/core";
import { computed, onMounted, watch } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";

import NoticeList from "@/components/notice/NoticeList.vue";
import VNav from "@/components/Nav.vue";
import ModalContainer from "@/components/modals/ModalContainer.vue";
import HeaderWrapper from "@/components/ui/header/HeaderWrapper.vue";
import ModalMobileContainer from "@/components/modals/ModalMobileContainer.vue";
import Footer from "@/components/ui/Footer.vue";
import { API_WITHOUT_GUARDS } from "@/assets/js/api/apiWithoutGuards";
import CookieModal from "@/components/ui/CookieModal.vue";
import { getCookie } from "@/assets/js/utils/helpers";

const store = useStore();
const route = useRoute();

const { width, height } = useWindowSize();

watch(
  width,
  (value) => {
    store.commit({
      type: "setWidth",
      value,
    });
  },
  { immediate: true }
);

watch(
  height,
  (value) => {
    store.commit({
      type: "setHeight",
      value,
    });
  },
  { immediate: true }
);
document.addEventListener("change", () => {
  store.commit({
    type: "setHeight",
    value: document.documentElement.clientHeight,
  });
  store.commit({
    type: "setWidth",
    value: document.documentElement.clientWidth,
  });
});

const showCookie = computed(() => {
  return store.state.general.showCookie;
});

const isNotices = computed(() => {
  return store.state.notices.isNotices;
});

const isFooter = computed(() => {
  return store.state.clientRestaurants.isFooter;
});

const isMenuShown = computed(() => {
  return store.getters.screenType !== "desktop" && store.state.general.isMenu;
});

const isWidgetPage = computed(() => {
  return route.name === "widget";
});

const hideHeader = computed(() => {
  const isMobile = store.getters.screenType === "mobile";
  const isHomePage = route.name === "home";
  const isMap = route.name === "map";
  const isHomeCateringPage = route.name === "map/:catId";
  const isBookingMaster = route.name === "booking";
  const { isAuthPage } = store.state.clientRestaurants;
  const { isMenu } = store.state.general;
  const { isDemo } = store.state.booking_master;

  if (isMobile) {
    if (isDemo) {
      return true;
    }
    if (isBookingMaster) {
      return false;
    }

    if (isHomePage || isHomeCateringPage || isMap) {
      return !(isAuthPage || isMenu);
    }
    return false;
  }

  return false;
});

onMounted(async () => {
  document.addEventListener("gesturestart", function (e) {
    e.preventDefault();
  });
  const { data } = await API_WITHOUT_GUARDS.general.getCities();
  store.commit({
    type: "setCities",
    value: data,
  });
  const cookieShown = getCookie("isCookieShown");
  if (!cookieShown) {
    store.commit({
      type: "setShowCookie",
      value: true,
    });
  }
});
</script>

<style lang="scss">
main {
  position: relative;
  display: flex;
  min-height: calc(100% - 68px);
  height: calc(100% - 68px);

  @include mobile {
    min-height: calc(100% - 64px);
    height: calc(100% - 64px);
    flex-direction: column;
  }

  &._widget {
    min-height: calc(100% - 88px);
    height: calc(100% - 88px);

    @include mobile {
      min-height: calc(100% - 68px);
      height: calc(100% - 68px);
    }
  }

  &._full {
    min-height: 100%;
    height: 100%;
  }

  &._footer {
    min-height: calc(100% - 68px - 188px);
    height: calc(100% - 68px - 188px);

    @include l-laptop {
      min-height: calc(100% - 68px - 268px);
      height: calc(100% - 68px - 268px);
    }
  }
}
</style>
